const MAX_MESSAGE_LENGTH = 500;
const MAX_CONTEXT_LENGTH = 2_000;

interface ClientErrorDetail {
  readonly context?: string;
  readonly message: string;
  readonly name: string;
  readonly source: 'react' | 'window';
}

export function captureClientError(error: unknown, context?: string): void {
  const normalized = normalizeError(error, context);
  // eslint-disable-next-line no-console -- console is the safe default adapter until a provider is configured.
  console.error('[FinanceGo client error]', normalized);
  window.dispatchEvent(
    new CustomEvent<ClientErrorDetail>('financego:client-error', {
      detail: normalized,
    }),
  );
}

export function installClientErrorCapture(): () => void {
  const onError = (event: ErrorEvent) => {
    captureClientError(event.error ?? event.message, `${event.filename}:${String(event.lineno)}`);
  };
  const onRejection = (event: PromiseRejectionEvent) => {
    captureClientError(event.reason);
  };

  window.addEventListener('error', onError);
  window.addEventListener('unhandledrejection', onRejection);
  return () => {
    window.removeEventListener('error', onError);
    window.removeEventListener('unhandledrejection', onRejection);
  };
}

function normalizeError(error: unknown, context?: string): ClientErrorDetail {
  const named = error instanceof Error;
  return {
    ...(context ? { context: context.slice(0, MAX_CONTEXT_LENGTH) } : {}),
    message: (named ? error.message : String(error)).slice(0, MAX_MESSAGE_LENGTH),
    name: named ? error.name : 'UnknownError',
    source: context ? 'react' : 'window',
  };
}
